import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe that truncates a string to a specified number of words and appends an ellipsis.
 *
 * @example
 * {{ longText | truncateParagraph:30 }}
 */
@Pipe({
  name: 'truncateParagraph'
})
export class TruncateParagraphPipe implements PipeTransform {
  /**
   * Truncates the value to at most `wordLimit` words.
   * Appends `…` when truncation occurs.
   *
   * @param value - The string to truncate.
   * @param wordLimit - Maximum number of words to keep (default: 50).
   */
  transform(value: string, wordLimit = 50): string {
    if (!value) {
      return '';
    }

    // Split on whitespace runs; filter tokens that have at least one alphanumeric character
    // so punctuation-only tokens (e.g. "---") do not inflate the word count.
    const tokens = value.split(/(\s+)/); // preserve whitespace tokens for faithful rebuild ensuring the output closely matches the original input's
    let wordCount = 0;
    let result = '';

    for (const token of tokens) {
      // A "word" token contains at least one alphanumeric character
      // Using `[a-zA-Z0-9]` for the regex instead of `/w` because `/w` includes underscore which we don't want.
      const isWord = /[a-zA-Z0-9]/.test(token);

      if (isWord) {
        if (wordCount >= wordLimit) {
          // We have already collected enough words — truncate here
          return `${result.trimEnd()}…`;
        }
        wordCount++;
      }

      result += token;
    }

    // Fewer words than the limit — return as-is
    return value;
  }
}
